export default "__VITE_PUBLIC_ASSET__3a0b974a__"